import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { PreviewImageModalModule } from 'Angular/features/components/modals/preview-image-modal/preview-image-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class TemplateModalModule {
}
TemplateModalModule.ɵfac = function TemplateModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TemplateModalModule)(); };
TemplateModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TemplateModalModule });
TemplateModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule, FormsModule, PreviewImageModalModule, IconModule] });
